import { useInScopeModel } from '@cotera/client/v0/actions/framework';
import { DevModeModel } from './dev-mode.model';

import { useAtomValue } from 'jotai';
import { DevModeStatus } from './types';

export const useDevModeStatus = () => {
  const model = useInScopeModel(DevModeModel)!;
  const devModeEnabled = useAtomValue(model.enabled.asAtom());

  return devModeEnabled ? DevModeStatus.On : DevModeStatus.Disabled;
};
